<!-- Footer Start -->
<div
  class="container-fluid bg-dark text-light footer mt-5 pt-5 wow fadeIn"
  data-wow-delay="0.1s">
  <div class="container py-5">
    <div class="row g-5">
      <div class="col-md-6">
        <h4 class="text-light mb-4">Dirección</h4>
        <!-- TODO -->
        <p class="mb-2">
          <i class="fa fa-map-marker-alt me-3"></i>Domicilio conocido, S/N Monterrey, N.L.
        </p>
        <!-- <p class="mb-2"><i class="fa fa-phone-alt me-3"></i>+52 99 9999 9999</p> -->
        <p class="mb-2"><i class="fa fa-envelope me-3"></i>contacto&#64;fibrainn.mx</p>
      </div>

      <div class="col-lg-3 col-md-6">
        <h4 class="text-light mb-4">Consulta nuestro aviso de privacidad</h4>
        <p>
          Nuestros términos y condiciones se encuentran detallados en el
          siguiente link.
          <a
            href="https://fibrainn.mx/aviso-privacidad"
            target="_blank"
            class="text-yellow">
            Términos y Condiciones
          </a>
        </p>
      </div>
    </div>
  </div>
  <div class="container">
    <div class="copyright">
      <div class="row">
        <div class="col-md-6 text-center text-md-start mb-3 mb-md-0">
          Fibra Inn - {{ year }}
        </div>
        <div class="col-md-6 text-center text-md-end">
          <!--/*** This template is free as long as you keep the footer author’s credit link/attribution link/backlink. If you'd like to use the template without the footer author’s credit link/attribution link/backlink, you can purchase the Credit Removal License from "https://htmlcodex.com/credit-removal". Thank you for your support. ***/-->
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Footer End -->
